"use strict";

exports.__esModule = true;
function numberToHex(value) {
  var hex = value.toString(16);
  return hex.length === 1 ? "0" + hex : hex;
}

exports.default = numberToHex;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./node_modules/polished/lib/internalHelpers/_numberToHex.js
// module id = 55
// module chunks = 0